/**
 * État du dossier client — source de vérité unique pour le tableau de bord,
 * Mes recommandations et Résultats d'analyses.
 *
 * L'API n'expose pas de statut de dossier : on le dérive de `recommandation_ia_statut`
 * (`brouillon` | `en_attente` | `publiee` | `non_generee`) et de `recommandation_ia_validee`.
 */
import axios from 'axios';

export const DOSSIER_STATE = {
  /** Aucune analyse transmise : le client est encore dans le questionnaire. */
  QUESTIONNAIRE: 'questionnaire_incomplete',
  /** Analyse transmise, en cours de revue par les équipes. */
  REVIEW: 'submitted',
  /** Analyse et recommandations disponibles pour le client. */
  PUBLISHED: 'published',
};

/** Détail d'analyse renvoyé sous `details` (latest=true) ou directement. */
export function normalizeLatestAnalyse(payload) {
  if (!payload || typeof payload !== 'object') return null;
  const details = payload.details;
  if (details && typeof details === 'object') return details;
  if (payload.recommandation_ia_statut !== undefined || payload.id !== undefined) return payload;
  return null;
}

export function isAnalysePublished(analyse) {
  if (!analyse) return false;
  const statut = String(analyse.recommandation_ia_statut || '').trim().toLowerCase();
  return statut === 'publiee' || !!analyse.recommandation_ia_validee;
}

export function deriveDossierState(latestAnalyse) {
  if (isAnalysePublished(latestAnalyse)) return DOSSIER_STATE.PUBLISHED;
  if (latestAnalyse) return DOSSIER_STATE.REVIEW;
  return DOSSIER_STATE.QUESTIONNAIRE;
}

/**
 * Lit l'état du dossier sans exiger le code bilan.
 * `latest=true` est la seule branche de /api/analyse-patrimoniale/ ouverte au client
 * sans code : elle permet de savoir s'il y a lieu de demander le code avant de l'afficher.
 * @returns {Promise<{ state: string, latestAnalyse: object|null }>}
 */
export async function fetchDossierState({ ordreDuo = null } = {}) {
  const params = { latest: 'true' };
  if (ordreDuo === 1 || ordreDuo === 2) params.ordre_duo = ordreDuo;
  const { data } = await axios.get('/api/analyse-patrimoniale/', {
    params,
    withCredentials: true,
  });
  const latestAnalyse = normalizeLatestAnalyse(data);
  return { state: deriveDossierState(latestAnalyse), latestAnalyse };
}
